import type { Router } from 'vue-router';

/**
 * Opens the "Phiếu xuất kho" PDF viewer page in a new browser tab.
 */
export function openPhieuXuatKhoPdf(
  router: Router,
  idPhieuXuatKho: number | string | null | undefined
): void {
  if (!idPhieuXuatKho) return;

  const route = router.resolve({
    name: 'xem-phieu-xuat-kho',
    params: { id: String(idPhieuXuatKho) },
  });

  window.open(route.href, '_blank');
}
